export default __webpack_public_path__ + "static/media/down_arrow.01c88d48.png";